import type { OnlineOperator } from "./support";

// Public display data only. Never accept arbitrary remote image URLs.
export function parseOnlineTeam(value: unknown, workerOrigin: string): OnlineOperator[] {
  if (!Array.isArray(value)) return [];
  const prefix = `${workerOrigin}/api/public/operator-photos/`;
  return value.slice(0, 20).flatMap((item) => {
    if (!item || typeof item !== "object" || typeof item.name !== "string" || !item.name.trim()) return [];
    const url = typeof item.photoUrl === "string" ? item.photoUrl : "";
    const valid = url.startsWith(prefix) && /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(url.slice(prefix.length));
    return [{ name: item.name.trim().slice(0, 60), photoUrl: valid ? url : null }];
  });
}
